export default "__VITE_ASSET__Wb30b8UH__"